// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"923":"416fb347","925":"416fb347"}[chunkId] + ".chunk.css";
};